import { lazyLoad } from 'routes/LazyLoad';
import { RouteObject } from 'react-router-dom';
import { PATH } from '../routeConfig';
export const notificationRoutes: RouteObject[] = [
  {
    path: PATH.NOTIFICATION,
    element: lazyLoad(() => import('pages/Notification')),
  },
];
